import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './NTextAreaQuill.css'; // Create a SCeS file for styling
import {
    getInputFieldStyleClasses,
    getTextareaLabelStyleClasses,
    TextareaProps,
} from '@novonordisk/novoui-vuejs';
import { NIcon } from '@innersource-nn/novoui-react';
import 'react-quill/dist/quill.snow.css'; // Import the Snow theme CSS

interface TextAreaQuillProps extends TextareaProps {
    onChange?: (value: string) => void;
}
function NTextAreaQuill({
    variant,
    assistiveText,
    modelValue,
    label,
    invalid,
    placeholder,
    disabled,
    onChange,
    ...rest
}: TextAreaQuillProps) {
    const textareaLabelStyleClasses = getTextareaLabelStyleClasses({
        variant,
        modelValue,
    });
    const inputFieldStyleClasses = getInputFieldStyleClasses(variant);

    return (
        <label
            className={`input  
                        text-area ${textareaLabelStyleClasses} ${disabled && 'input-disabled'}
              ${invalid && 'input-invalid'}`}
        >
            <ReactQuill
                theme="snow"
                className={`input-field ${inputFieldStyleClasses}`}
                {...rest}
                placeholder={placeholder}
                value={modelValue}
                onChange={onChange}
            />
            {label && <span className="input-label">{label}</span>}
            {assistiveText && (
                <div className="input-assistive">
                    {invalid && <NIcon iconName="warning" size={12} />}
                    {assistiveText}
                </div>
            )}
        </label>
    );
}

export default NTextAreaQuill;
